import { create } from 'zustand';
import { Id } from '@/convex/_generated/dataModel';

interface SelectedPodStore {
	selectedPod: Id<'engagementPods'> | null;
	setSelectedPod: (pod: Id<'engagementPods'> | null) => void;
}

export const useSelectedPodStore = create<SelectedPodStore>((set) => ({
	selectedPod: null,
	setSelectedPod: (pod) => set({ selectedPod: pod }),
}));
